const TrialingIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.54961 18L3.84961 12.3L5.27461 10.875L9.54961 15.15L18.7246 5.97501L20.1496 7.40001L9.54961 18Z"
      fill="#0A8081"
    />
  </svg>
);

export default TrialingIcon;
